import { Terminal } from "lucide-react";

export default function Footer() {
  return (
    <footer
      data-testid="footer"
      className="py-12 px-6"
      style={{ borderTop: "1px solid rgba(255,255,255,0.06)" }}
    >
      <div className="max-w-6xl mx-auto flex flex-col sm:flex-row items-center justify-between gap-6">
        <div className="flex items-center gap-2">
          <Terminal className="w-4 h-4 text-white" strokeWidth={2.5} />
          <span
            className="text-sm font-bold tracking-tighter text-white"
            style={{ fontFamily: "'Outfit', sans-serif" }}
          >
            runzr
          </span>
        </div>
        <p className="text-xs" style={{ color: "#71717A" }}>
          The mobile control layer for AI coding sessions.
        </p>
        <p className="text-xs" style={{ color: "#71717A" }}>
          &copy; {new Date().getFullYear()} Runzr. All rights reserved.
        </p>
      </div>
    </footer>
  );
}
